import { IPlayableItems } from '@communication-center/data-objects';
import { Notification } from '../../../../models';
import { PublishStatus, TypeId } from '@walkme/types';
import { ContentItemType } from '@walkme/client-lib';

const typeIdToTypeName = (typeId: number) => {
    switch (typeId) {
        case TypeId.Shuttle:
            return ContentItemType.Shuttle;
        case TypeId.SmartWalkThru:
            return ContentItemType.SmartWalkThru;
        case TypeId.Content:
            return ContentItemType.Resource;
        default:
            throw new Error("type isn't supported");
    }
};

const findNonPublishedPlayableItems = ({ deps, playableItems }: { deps: Map<$TSFixMe, $TSFixMe>; playableItems: $TSFixMe }) => {
    const depMap: Array<{ type: number; checkedIds: Array<string | number | $TSFixMe> }> = [];

    Array.from(deps.keys()).forEach((type: TypeId) => {
        const typeId = +type;
        const typeName: string = typeIdToTypeName(typeId);
        const allTypeItems = playableItems?.[typeName] || [];

        const nonPublished = Array.from(deps.get(typeId)).filter(playable =>
            allTypeItems.find((item: $TSFixMe) => item.id === playable && (item.publishStatus != PublishStatus.Published || item.isModified))
        );

        if (nonPublished.length > 0) {
            depMap.push({ type: typeId, checkedIds: nonPublished });
        }
    });

    return depMap;
};

export function getUnPublishedDependencies({ notifications, playableItems }: { notifications: Notification[]; playableItems: IPlayableItems }) {
    const deps = new Map<TypeId, Set<string | number>>();

    notifications.forEach(notification => {
        notification?.dependencies?.forEach?.(dep => {
            const key = dep.dependencyType;
            // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'TypeId | undefined' is not assig... Remove this comment to see the full error message
            const value = deps.get(key) || new Set<string | number>();
            // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | number | undefined' is ... Remove this comment to see the full error message
            value.add(dep.dependencyId);
            // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'TypeId | undefined' is not assig... Remove this comment to see the full error message
            deps.set(key, value);
        });
    });

    return findNonPublishedPlayableItems({ deps, playableItems });
}
